var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('alter-form',{ref:"alterform",attrs:{"customeButton":true,"watchImageVisible":false,"modifyData":_vm.data,"formData":_vm.formData},on:{"handleAppend":_vm.handleAppend,"formSubmit":_vm.formSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }